import { getSocketIOUrl as getSocketIOUrlFromConfig } from './socket';
const getApiBaseUrl = () => {
    if (typeof window !== 'undefined') {
        const { port, hostname, protocol } = window.location;
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
        if (isLocalhost && port === '8080') {
            return 'http://localhost:5000';
        }
        if (isLocalhost && (!port || port === '80' || port === '443')) {
            return '';
        }
        if (!port || port === '80' || port === '443' || port === '3001') {
            return '';
        }
        if (!isLocalhost) {
            const apiUrl = `${protocol}//${hostname}:5000`;
            console.log('[API] Usando IP da rede para API:', apiUrl);
            return apiUrl;
        }
    }
    console.log('[API] Fallback para URL relativa');
    return '';
};
const API_BASE_URL = getApiBaseUrl();
export const API_ENDPOINTS = {
    // Sistema
    SISTEMA_CONFIGURACOES: `${API_BASE_URL}/api/sistema/configuracoes`,
    SISTEMA_BACKUPS: `${API_BASE_URL}/api/sistema/backups`,
    SISTEMA_BACKUP_CREATE: `${API_BASE_URL}/api/sistema/backup/create`,
    SISTEMA_BACKUP_DOWNLOAD: (backupId) => `${API_BASE_URL}/api/sistema/backup/download/${backupId}`,
    SISTEMA_BACKUP_DELETE: (backupId) => `${API_BASE_URL}/api/sistema/backup/${backupId}`,
    SISTEMA_LOGS: `${API_BASE_URL}/api/sistema/logs`,
    SISTEMA_LOGS_EXPORT: `${API_BASE_URL}/api/sistema/logs/export`,
    SISTEMA_LOGS_LIMPAR: `${API_BASE_URL}/api/sistema/logs/limpar`,
    SISTEMA_LOGS_ESTATISTICAS: `${API_BASE_URL}/api/sistema/logs/estatisticas`,
    SISTEMA_OTIMIZADOR_BANCO_RELATORIO: `${API_BASE_URL}/api/sistema/otimizador-banco/relatorio`,
    EMAIL_ENVIAR: `${API_BASE_URL}/api/email/enviar`,
    // Autenticacao
    LOGIN: `${API_BASE_URL}/api/login`,
    REGISTER: `${API_BASE_URL}/api/register`,
    ALTERAR_SENHA: `${API_BASE_URL}/api/alterar-senha`,
    // APIs principais
    CIDADES: `${API_BASE_URL}/api/cidades`,
    USUARIOS: `${API_BASE_URL}/api/usuarios`,
    PERFIS: `${API_BASE_URL}/api/perfis`,
    EMPRESAS: `${API_BASE_URL}/api/empresas`,
    COLABORADORES: `${API_BASE_URL}/api/colaboradores`,
    SETORES: `${API_BASE_URL}/api/setores`,
    // Cadastro de Colaboradores
    CADASTRO_COLABORADORES: `${API_BASE_URL}/api/cadastro-colaboradores`,
    CADASTRO_COLABORADOR_BY_ID: (id) => `${API_BASE_URL}/api/cadastro-colaboradores/${id}`,
    // Carros
    CARROS: `${API_BASE_URL}/api/carros`,
    CARROS_COLABORADORES: `${API_BASE_URL}/api/carros/colaboradores`,
    CARROS_DISTRIBUICAO: `${API_BASE_URL}/api/carros/distribuicao`,
    CARROS_HISTORICO: `${API_BASE_URL}/api/carros/historico`,
    // Hora Extra
    HORA_EXTRA: `${API_BASE_URL}/api/hora-extra`,
    HORA_EXTRA_SOLICITACOES: `${API_BASE_URL}/api/hora-extra/solicitacoes`,
    HORA_EXTRA_APROVACOES: `${API_BASE_URL}/api/hora-extra/aprovacoes`,
    RH_ABSENTEISMO_HORAS: `${API_BASE_URL}/api/rh/absenteismo-terceiros`,
    RH_ABSENTEISMO_HORAS_RELATORIO: `${API_BASE_URL}/api/rh/absenteismo-terceiros/relatorio`,
    RH_PLANO_CONTINGENCIA: `${API_BASE_URL}/api/rh/plano-contingencia`,
    // Financeiro
    FINANCEIRO: `${API_BASE_URL}/api/financeiro`,
    FINANCEIRO_RELATORIOS: `${API_BASE_URL}/api/financeiro/relatorios`,
    // Chat
    CHAT_CONVERSAS: `${API_BASE_URL}/api/chat/conversas`,
    CHAT_MENSAGENS: `${API_BASE_URL}/api/chat/mensagens`,
    // Portaria
    PORTARIA: `${API_BASE_URL}/api/portaria`,
    PORTARIA_REGISTROS: `${API_BASE_URL}/api/portaria/registros`,
    // Terceiros
    TERCEIROS_LANCAMENTOS: `${API_BASE_URL}/api/terceiros/lancamentos`,
    TERCEIROS_LANCAMENTOS_BATCH: `${API_BASE_URL}/api/terceiros/lancamentos/batch`,
    TERCEIROS_LANCAMENTOS_IMPORTAR_PLANILHA: `${API_BASE_URL}/api/terceiros/lancamentos/importar-planilha`,
    TERCEIROS_EMPRESAS: `${API_BASE_URL}/api/terceiros/empresas`,
    TERCEIROS_DIAS_LANCAMENTO: (empresaId) => `${API_BASE_URL}/api/terceiros/empresas/${empresaId}/dias-lancamento`,
    // Recepcao
    RECEPCAO: `${API_BASE_URL}/api/recepcao`,
    RECEPCAO_VISITANTES: `${API_BASE_URL}/api/recepcao/visitantes`,
    // Beneficios
    BENEFICIOS_HORARIOS: `${API_BASE_URL}/api/beneficios/horarios`,
    BENEFICIOS_STATUS: `${API_BASE_URL}/api/beneficios/status`,
    BENEFICIOS_HORARIO_ATIVO: `${API_BASE_URL}/api/beneficios/horarios/ativo`,
    // Health Check
    HEALTH: `${API_BASE_URL}/health`,
};
export const getSocketIOUrl = () => {
    return getSocketIOUrlFromConfig();
};
export default API_BASE_URL;
